<template>
  <div class="d-flex align-content-center" style="flex: 1">
    <v-icon color="primary" class="me-2">mdi-map-marker</v-icon>
    <!-- SELECT LOCATION -->
    <div>
      <v-select
        style="max-width: 300px"
        class="me-8"
        :hint="`test`"
        :items="locationOptions"
        item-value="id"
        persistent-hint
        label="Loading"
        hide-details
        :loading="loadingLocations"
        :disabled="loadingLocations"
        solo
        dense
        :value="selectedLocation"
        single-line
        @change="setLocation($event)"
      >
        <template v-slot:selection="{ item }">
          {{ item.location }}
        </template>
        <template v-slot:item="{ item }">
          <div>{{ item.location }}</div>
          <div class="caption ms-2 grey--text">{{ item.address }} {{ item.id }}</div>
        </template>
      </v-select>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loadingLocations: false
    };
  },
  computed: {
    locationOptions() {
      return this.$store.state.appointmentsCalendarStore.locationOptions;
    },
    selectedLocation() {
      return this.$store.state.appointmentsCalendarStore.locationSelected;
    }
  },
  async created() {
    this.getLocations();
    this.setSelectedLocationLocalStorage();
  },
  methods: {
    async getLocations() {
      if (this.locationOptions?.length === 0) {
        this.loadingLocations = true;
        await this.$store.dispatch('appointmentsCalendarStore/getLocationOptions');
        //if no location selected, set first
        if (!this.selectedLocation) {
          this.setLocation(this.locationOptions[0].id);
        }
        this.loadingLocations = false;
      }
    },
    removeLocation() {
      this.$store.commit('appointmentsCalendarStore/SET_SELECTED_LOCATION', null);
    },
    setLocation(locationSelectedId) {
      const selectedLocation = this.locationOptions.find((location) => location.id == locationSelectedId);
      localStorage.setItem(`${this.$store.getters.appSlug}_appointmentsCalendarSelectedLocation`, JSON.stringify(selectedLocation));
      this.$store.commit('appointmentsCalendarStore/SET_SELECTED_LOCATION', selectedLocation);
      this.$emit('locationChanged');
    },
    setSelectedLocationLocalStorage() {
      if (!this.selectedLocation) {
        const selectedLocationLocalStorage = localStorage.getItem(`${this.$store.getters.appSlug}_appointmentsCalendarSelectedLocation`);
        if (selectedLocationLocalStorage) {
          this.$store.commit('appointmentsCalendarStore/SET_SELECTED_LOCATION', JSON.parse(selectedLocationLocalStorage));
        }
      }
    }
  }
};
</script>

<style>
.display-location {
  background-color: rgba(255, 255, 255, 0.7) !important;
}
</style>